import React from "react";
import { Link } from "react-router-dom";

/**
 * Ordernummer, zendingnummer of factuurnummer als link.
 *
 * In het oude overzicht stonden gekoppelde inkooporders als blauwe `Tag`. Een
 * tag leest als een status; deze dingen zijn navigatie. Daarom een echte link,
 * met vaste cijferbreedte zodat nummers in een kolom uitlijnen.
 */
const RecordLink = ({ to, children, onClick, size = 13, style, ...rest }) => {
  const linkStyle = {
    fontVariantNumeric: "tabular-nums",
    fontSize: size,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "inline-block",
    maxWidth: "100%",
    ...style,
  };

  // Rijen in de overzichten zijn zelf klikbaar; stop de bubble zodat een klik
  // op het nummer naar dát record gaat en niet naar de rij eronder.
  const stop = (event) => {
    event.stopPropagation();
    if (onClick) onClick(event);
  };

  if (!to) {
    return (
      <span style={linkStyle} {...rest}>
        {children}
      </span>
    );
  }

  return (
    <Link to={to} onClick={stop} style={linkStyle} {...rest}>
      {children}
    </Link>
  );
};

export default RecordLink;
